import Vue from 'vue';
import VueRouter from 'vue-router';

// VueRouter.prototype.push = function(path) {
//   return routerPush.call(this, path).catch(err => err);
// };

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'login', // 这个名称要与themes文件名称相同
    meta: {
      cname: 'login',
    },
    component: () => import(/* webpackChunkName: "ChengShiZhiLi" */ '../views/Login.vue')
  },
  {
    path: '/protDistribution',
    name: 'protDistribution', // 这个名称要与themes文件名称相同
    meta: {
      cname: 'protDistribution',
      showName: 'Prot Distribution'
    },
    component: () => import(/* webpackChunkName: "ChengShiZhiLi" */ '../views/protDistribution.vue')
  },
  {
    path: '/portSituation',
    name: 'portSituation', // 这个名称要与themes文件名称相同
    meta: {
      cname: 'portSituation',
      showName: 'Port Situation'
    },
    component: () => import(/* webpackChunkName: "ChengShiZhiLi" */ '../views/portSituation.vue')
  },
  {
    path: '/maritimeSafety',
    name: 'maritimeSafety', // 这个名称要与themes文件名称相同
    meta: {
      cname: 'maritimeSafety',
      showName: 'Maritime Safety'
    },
    redirect: '/maritimeSafety/BerthedVessels',
    component: () => import(/* webpackChunkName: "ChengShiZhiLi" */ '../views/SubPage.vue'),
    children: [
      {
        path: '/maritimeSafety/BerthedVessels',
        name: 'maritimeSafety',
        meta: {
          cname: 'maritimeSafety',
          showName: 'Maritime Safety',
          imgUrl: {
            def: 'img/layout/BerthedVessels',
            act: 'img/layout/BerthedVessels_ac'
          }
        },
        component: () => import('../views/maritimeSafety.vue')
      },
      {
        path: '/maritimeSafety/EmergencyCommand',
        name: 'EmergencyCommand',
        meta: {
          cname: 'EmergencyCommand',
          showName: 'Emergency Command',
          imgUrl: {
            def: 'img/layout/EmergencyCommand',
            act: 'img/layout/EmergencyCommand_ac'
          }
        },
        component: () => import('../views/EmergencyCommand.vue')
      }
    ]
  },
  {
    path: '/terminalOperations',
    name: 'terminalOperations', // 这个名称要与themes文件名称相同
    meta: {
      cname: 'terminalOperations',
      showName: 'Terminal Operations'
    },
    component: () => import(/* webpackChunkName: "ChengShiZhiLi" */ '../views/terminalOperations.vue')
  },
  {
    path: '/yardManagement',
    name: 'yardManagement', // 这个名称要与themes文件名称相同
    meta: {
      cname: 'yardManagement',
      showName: 'Yard Management'
    },
    component: () => import(/* webpackChunkName: "ChengShiZhiLi" */ '../views/yardManagement.vue')
  }
];

const router = new VueRouter({
  routes
});

export default router;
